import axios from "axios";
import { useContext, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import UserSearchForm from "../../../components/Users/UserSearchForm";
import { UserContext } from "../../../Context/UserContextAPI";
import { savePDF } from "@progress/kendo-react-pdf";

const DateWiseMedicalSummary = () => {
  const {
    introducerUsers,
    accessPerm,
    companyUsers,
    delegateUsers,
    representativeUsers,
    packages,
  } = useContext(UserContext);

  const newPackage = [...packages, { id: 999999, name: "Individual" }];

  const [summaryData, setSummaryData] = useState([]);
  const [dateRange, setDateRange] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
  });
  const [pdfGenerating, setPdfGenerating] = useState(false);

  const pdfRef = useRef(null);

  const fetchSummaryData = async (formData) => {
    try {
      const params = new URLSearchParams(formData);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
          "/v2/users/get-date-wise-user-count?" +
          params.toString(),
      );
      setSummaryData(res.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const pdfGenerate = async () => {
    setPdfGenerating(true);
    const element = pdfRef.current;

    element.style.fontWeight = "bold";
    element.style.height = "75vh";
    element.style.fontSize = "12px";
    // element.style.fontFamily = "Verdana";
    savePDF(element, {
      paperSize: "auto",
      margin: 10,
      padding: 0,
      fontWeight: "900",
      fontFamily: "Lucida Sans Unicode",
      fileName: `Date wise Summary Report`,
    });
    setPdfGenerating(false);
  };

  return (
    <div className="">
      <div className="card">
        <div className="card-body">
          <div className="rounded">
            <div className="card shadow-none mb-3">
              <div className="border p-3 rounded">
                <h6
                  className="mb-0 btn btn-danger text-white text-capitalize fw-bold m-0 p-0"
                  style={{ cursor: "default" }}
                >
                  Date Wise Medical Summary Report
                </h6>
              </div>
            </div>
            <UserSearchForm
              userSearchHandler={(e) => {
                setDateRange(e);
                fetchSummaryData(e);
              }}
              inlineButtonComponent={
                <button
                  type="button"
                  className="btn btn-success border border-3"
                  onClick={(e) => pdfGenerate(e)}
                  style={{ whiteSpace: "nowrap" }}
                  disabled={pdfGenerating}
                >
                  {pdfGenerating ? "Generating PDF..." : "Download PDF"}
                </button>
              }
            />
          </div>
          <div ref={pdfRef} className="mt-4">
            <div className="text-center">
              <p className="mb-0">Date wise Medical Summary Report</p>
              <p className="mb-0">
                Date: {dateRange.fromDate} to {dateRange.toDate}
              </p>
            </div>
            <Table bordered className="mt-4">
              <thead>
                <tr style={{ backgroundColor: "teal", color: "white" }}>
                  <td>Date</td>
                  {newPackage?.map((p) => (
                    <td key={p.id}>{p.name}</td>
                  ))}
                  <td>Total</td>
                </tr>
              </thead>
              <tbody>
                {summaryData?.map((summary) => {
                  return (
                    <tr key={summary?.date}>
                      <td>{summary?.date}</td>
                      {newPackage?.map((p) => {
                        return <td> {summary.packagewise[p?.name]} </td>;
                      })}

                      <td>{summary?.total}</td>
                    </tr>
                  );
                })}
                <tr style={{ backgroundColor: "teal", color: "white" }}>
                  <td>Total</td>
                  {newPackage?.map((p) => {
                    return (
                      <td>
                        {" "}
                        {summaryData.reduce(
                          (acc, curr) => acc + (curr.packagewise[p?.name] || 0),
                          0,
                        )}{" "}
                      </td>
                    );
                  })}
                  <td>
                    {summaryData.reduce((acc, curr) => acc + curr.total, 0)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateWiseMedicalSummary;
